// extracted by mini-css-extract-plugin
module.exports = {"image":"_1oRFXS"};